import { render } from "./CardFooter.vue?vue&type=template&id=a4bfc340"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4bfc340"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4bfc340', __exports__)) {
    api.reload('a4bfc340', __exports__)
  }
  
  module.hot.accept("./CardFooter.vue?vue&type=template&id=a4bfc340", () => {
    api.rerender('a4bfc340', render)
  })

}


export default __exports__